import { createFileRoute, redirect } from '@tanstack/react-router';

import { scope1SearchSchema } from '@/features/ghg/pages/GhgScope1CalculationsPage';

export const Route = createFileRoute('/_authenticated/ghg/calculations/scope1')({
  validateSearch: scope1SearchSchema,
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/ghg/emissions', search: { scope: 1 }, replace: true });
  },
});
